import axios from 'axios';

export class InventoryAPI {
  #instance;
  #baseHeaders;

  constructor({ baseUrl } = {}) {
    this.#instance = axios.create({ baseURL: baseUrl });
    this.#baseHeaders = { 'X-Search-Request': true };
  }

  async getInventoryHTML(path, params = {}) {
    const reqHeaders = new axios.AxiosHeaders(this.#baseHeaders);
    return this.#instance.get(path, { headers: reqHeaders, params });
  }

  async getInventory(params = {}) {
    const reqHeaders = new axios.AxiosHeaders(this.#baseHeaders);
    return this.#instance.get('/api/search', { headers: reqHeaders, params });
  }

  async getSearchResultsWidget(params = {}) {
    return this.loadAsyncWidget('search-results', { params });
  }

  async loadAsyncWidget(widgetSlug, { params = {} } = {}) {
    const reqHeaders = new axios.AxiosHeaders(this.#baseHeaders);
    return this.#instance.get(`/widget/${widgetSlug}`, { headers: reqHeaders, params });
  }
}
